import { Skeleton, SkeletonItem } from '@capsicum/common-web';
import styled from 'styled-components';

export const SumsubSkeleton = () => {
	return (
		<S.SkeletonWrapper height={65}>
			<S.SkeletonTitle height={40} />
			{Array.from({ length: 5 }, (_, i) => (
				<S.SkeletonInput key={i} />
			))}
		</S.SkeletonWrapper>
	);
};

SumsubSkeleton.displayName = 'SumsubSkeleton';

namespace S {
	export const SkeletonWrapper = styled(Skeleton)`
		display: flex;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacings.small};
	`;

	export const SkeletonTitle = styled(SkeletonItem)`
		border-radius: ${({ theme }) => theme.sizing.xxsmall};
		margin-bottom: ${({ theme }) => theme.spacings.large};
	`;

	export const SkeletonInput = styled(SkeletonItem)`
		border-radius: ${({ theme }) => theme.sizing.xxsmall};
		margin-bottom: ${({ theme }) => theme.spacings.xxsmall};
	`;
}
